import { defineStore } from "pinia";
import api from "@/services/api";

export interface Activity {
  id: string;
  activityType: string;
  title: string;
  message: string;
  userName: string;
  activityDate: string;
}

export interface Notification {
  id: string;
  title: string;
  message: string;
  activityDate: string;
}

type State = {
  isLoading: boolean;
  isNotificationLoading: boolean;
  activities: Activity[];
  notifications: Notification[];
};

export const useActivity = defineStore("activity", {
  state: (): State => ({
    isLoading: false,
    isNotificationLoading: false,
    activities: [] as Activity[],
    notifications: [] as Notification[],
  }),
  actions: {
    async fetchActivities() {
      this.isLoading = true;
      try {
        const { data } = await api.get(`activity`);
        this.activities = data;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async fetchNotifications() {
      this.isNotificationLoading = true;
      try {
        const { data } = await api.get(`notification`);
        this.notifications = data;
        this.isNotificationLoading = false;
      } catch (e) {
        this.isNotificationLoading = false;
      }
    },
  },
  getters: {
    getActivities({ activities }): Activity[] {
      return activities;
    },
    getNotifications({ notifications }): Notification[] {
      return notifications;
    },
  },
});
